import { combineReducers } from 'redux'
import { injectReducer } from '../../store/reducers'
import versionsRoute from './routes/Versions'
import casperInitRoute from './routes/CasperInit'
import productStatusInitRoute from './routes/ProductStatus'
import defaultsApplyRoute from './routes/ApplyDefaults'

export const createRoutes = store => ({
  path: 'button',
  childRoutes: [
    versionsRoute(store),
    casperInitRoute(store),
    productStatusInitRoute(store),
    defaultsApplyRoute(store)
  ],
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const Button = require('./containers/ButtonContainer').default
      const buttonReducer = require('./modules/button').default

      /*  Add the reducer to the store on key 'workflow'  */
      injectReducer(store, {
        key: 'button',
        reducer: combineReducers({
          button: buttonReducer
        })
      })

      /*  Return getComponent   */
      cb(null, Button)

      /* Webpack named bundle   */
    }, 'button')
  }
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/Button/index.js